module.exports = __webpack_public_path__ + "media/setup_payments.43f5826f.svg";